import { observeElement } from '@uvocore-front/utils';
import '../../components/ImagesLazyLoading';
import '../../components/NotifyWidget';
import '../../components/Calculator/CalculatorDefault';
import '../../all_pages/js/testimonials';
import '../../all_pages/js/headerScroll';
import '../../all_pages/js/toggleMenu';
import '../../all_pages/js/dropdown';
import Accordion from '../../components/Accordion';

observeElement({
  element: '.Accordion',
  marginValue: 300,
  callback: () => {
    Accordion();
  },
});
